module.exports = __webpack_public_path__ + "static/seller/img/ryhy.2dda780b.png";